import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Line, LineChart } from 'recharts';

const TrendSparkLineCell = ({ trends }: { trends: Record<string, number> }) => {
  const theme = useTheme();
  const hasData = Object.keys(trends).length > 0;

  return hasData ? (
    <LineChart
      data={Object.entries(trends).map(([date, value]) => ({
        date,
        value,
      }))}
      width={120}
      height={45}
    >
      <Line
        type='monotone'
        dataKey='value'
        stroke={theme.palette.primary[500]}
        strokeWidth={2}
        dot={false}
      />
    </LineChart>
  ) : (
    <Typography variant='subtitleLabel' component='span' color='text.secondary'>
      N/A
    </Typography>
  );
};

export default TrendSparkLineCell;
